module.exports = __webpack_public_path__ + "e716961f887bb33a86f6b5168b3ddbb9.png";